import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { PropertyCreationStep, PropertyDto, PropertyPresentationDto } from '@workspace/data-types';
import { DtoChangedDetection } from '@workspace/ng-aura';
import { PropertyMissingInfoUtils } from '../../../utils/property-missing-info.utils';
import { EtxePropertySectionReminderComponent } from '../../property-section-reminder/property-section-reminder.component';
import { PropertyPresentationDisplayComponent } from '../display/presentation-display.component';
import { PropertyPresentationFormComponent } from '../form/presentation-form.component';

@Component({
  selector: 'etxe-property-presentation-edit',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    PropertyPresentationDisplayComponent,
    PropertyPresentationFormComponent,
    EtxePropertySectionReminderComponent,
  ],
  templateUrl: './presentation-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyPresentationEditComponent {
  property = input.required<PropertyDto>();
  editMode = input.required<boolean>();
  editable = input<boolean>(true);
  saving = input<boolean>(false);

  missingItems = computed(() =>
    PropertyMissingInfoUtils.getMissingItemsByStep(this.property(), PropertyCreationStep.PRESENTATION),
  );

  editToggled = output<void>();
  cancelToggled = output<void>();
  dtoChanged = output<DtoChangedDetection<PropertyPresentationDto>>();
  submitted = output<void>();

  onEdit() {
    this.editToggled.emit();
  }

  onCancel() {
    this.cancelToggled.emit();
  }

  onDtoChanged(event: DtoChangedDetection<PropertyPresentationDto>) {
    this.dtoChanged.emit(event);
  }

  onSubmit() {
    this.submitted.emit();
  }
}
